(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-airplay"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-airplay"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-airplay.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-airplay.js":
/*!************************************!*\
  !*** ./src/mggp-plugin-airplay.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by User on 23/01/2017.
 */
var MggpPlugin = __webpack_require__(/*! mggp-player */ "mggp-player").Plugin;
function MggpPluginAirplay(player, config) {
	MggpPlugin.apply(this, arguments);
	var self = this;

	var EVENT_BUTTON_CLICK = 'airplay:event:buttonClick';
	var STATE = 'airplay:state';
	var STATE_AVAILABLE = 'available';
	var STATE_NOT_AVAILABLE = 'notAvailable';
	var STATE_CONNECTED = 'connected';

	var video = null;
	var needToCheck = true;
	var state = STATE_NOT_AVAILABLE;

	self.player.registerProperty(STATE, STATE_NOT_AVAILABLE, true);
	self.player.on('player:stateChange', onStateChanged);

	this.dispose = function () {
		self.player.off(EVENT_BUTTON_CLICK, onButtonClick);
		self.player.off('player:stateChange', onStateChanged);
		self.player.off('player:timeUpdate', onCheckConnectedState);
		if (video) {
			video.removeEventListener('webkitplaybacktargetavailabilitychanged', onAvailabilityChanged);
			video.removeEventListener('webkitcurrentplaybacktargetiswireless', onTargetIsWirelessChanged);
		}
		setState(STATE_NOT_AVAILABLE);

		needToCheck = false;
		video = null;
	};

	this.load = function (src, videoInfo, options) {
		needToCheck = true;
	};

	function onButtonClick(event) {
		if (video) {
			video.addEventListener('webkitcurrentplaybacktargetiswireless', onTargetIsWirelessChanged);
			video.webkitShowPlaybackTargetPicker();
			self.player.on('player:timeUpdate', onCheckConnectedState);
		}
	}

	function onStateChanged(event) {
		if (event.data === 1) {
			if (needToCheck) {
				needToCheck = false;
				checkAvailability();
			}
		} else if (event.data === 0) {
			self.player.off(EVENT_BUTTON_CLICK, onButtonClick);
			setState(STATE_NOT_AVAILABLE);
		}
	}

	function onAvailabilityChanged(event) {
		if (event.isTrusted) {
			video.removeEventListener('webkitplaybacktargetavailabilitychanged', onAvailabilityChanged);
		}
		switch (event.availability) {
			case "available":
				self.player.on(EVENT_BUTTON_CLICK, onButtonClick);
				setState(STATE_AVAILABLE);
				break;
			case "not-available":
				setState(STATE_NOT_AVAILABLE);
				self.player.off(EVENT_BUTTON_CLICK, onButtonClick);
				break;
		}
	}

	function onTargetIsWirelessChanged(event) {
		if (video) {
			video.removeEventListener('webkitcurrentplaybacktargetiswireless', onTargetIsWirelessChanged);
			if (video.webkitCurrentPlaybackTargetIsWireless) {
				setState(STATE_CONNECTED);
			} else {
				setState(STATE_AVAILABLE);
			}
		} else {
			setState(STATE_NOT_AVAILABLE);
		}
		self.player.off('player:timeUpdate', onCheckConnectedState);
	}

	function onCheckConnectedState(event) {
		if (video) {
			if (state !== STATE_CONNECTED && video.webkitCurrentPlaybackTargetIsWireless) {
				setState(STATE_CONNECTED);
				self.player.off('player:timeUpdate', onCheckConnectedState);
			} else if (state === STATE_CONNECTED && !video.webkitCurrentPlaybackTargetIsWireless) {
				setState(STATE_AVAILABLE);
				self.player.off('player:timeUpdate', onCheckConnectedState);
			}
		} else {
			setState(STATE_NOT_AVAILABLE);
			self.player.off('player:timeUpdate', onCheckConnectedState);
		}
	}

	function checkAvailability() {
		if (window.WebKitPlaybackTargetAvailabilityEvent) {
			video = self.player.getPlayableElement();
			if (video) {
				video.addEventListener('webkitplaybacktargetavailabilitychanged', onAvailabilityChanged);
			} else {
				onAvailabilityChanged({ availability: false });
			}
		} else {
			onAvailabilityChanged({ availability: false });
		}
	}

	function setState(newState) {
		state = newState;
		self.player.set(STATE, newState);
	}
}
MggpPluginAirplay.prototype = Object.create(MggpPlugin.prototype);
MggpPluginAirplay.prototype.constructor = MggpPluginAirplay;

module.exports = MggpPluginAirplay;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});